import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../Bookshelf/bookshelf.css";
import Spinner from "../Spinner/Spinner";
import { post } from "../../app/shared/http";
import { handleException } from "../../app/util/util";
import { Modal, Card, CardDeck } from "react-bootstrap";
import loaderColors1 from "../Spinner/loaderColors1.gif";
import { FaPlus, FaFilter, FaThumbtack } from "react-icons/fa";
import CqCoverImg from "./BookCoverImages/Connected_Quizzing_Cover_Image.jpg";
export default function BookRoom() {
  let history = useHistory();
  let userName = localStorage.getItem("userName");
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  userName =
    userName && userName.length > 10 ? userName.slice(0, 10) + "..." : userName;
  const [bookList, setBookList] = useState([]);
  const [redeemCode, setRedeemCode] = useState("");
  const [bookRoomList, setBookRoomList] = useState([]);
  const [redeemCodeErr, setRedeemCodeErr] = useState("");
  const [redeemSearchActive, setRedeemSearchActive] = useState("");
  const [isBookShelfLoading, setIsBookShelfLoading] = useState(true);
  const [isShowTutorialPopup, setIsShowTutorialPopup] = useState(false);
  const [showTutorialPopup, setShowTutorialPopup] = useState({
    popupHeading: "",
    popupDescr: "",
    popupVideoUrl: "",
  });
  useEffect(() => {
    document.title = "Casebook Connect Dashboard | Aspen Publishing";
    fetchBookList();
  }, []);
  const handleGetBookContent = (e) => {
    let bookType = e.target.getAttribute("booktype");
    let bookISBN = e.target.getAttribute("bookisbn");
    localStorage.setItem("bookIsbn", bookISBN);
    switch (bookType) {
      case "ConnectedQuiz":
        history.push(
          userVO.userRole === "Student" ? "/cq-student" : "/cq-professor",
        );
        break;
      case "PracticePerfect":
        history.push(
          `${userVO.userRole === "Student" ? "/pp-video-library/" : "/pp-classes/"}${bookISBN}`,
        );
        break;
      case "Resource":
        history.push(`/resources/${bookISBN}`);
        break;
      default:
        let userId = JSON.parse(localStorage.getItem("userVO")).userId;
        if (e.currentTarget.getAttribute("chapterid") !== null) {
          let chapterId = e.currentTarget.getAttribute("chapterid");
          history.push(`/read/users/${userId}/books/${bookISBN}/${chapterId}`);
        } else {
          let toc = e.currentTarget.getAttribute("tocpath");
          history.push(
            `/read/users/${userId}/books/${bookISBN}/${toc.split("/")[toc.split("/").length - 1].split(".")[0]}`,
          );
        }
        break;
    }
  };
  const getBookDisplayName = (book) => {
    if (book.bookType === "ConnectedQuiz") {
      return "Connected Quizzing";
    }

    if (book.bookType === "PracticePerfect") {
      return `PracticePerfect ${book.bookTitle}`;
    }

    return book.bookTitle;
  };
  const getPinAriaLabel = (book) => `Pin ${getBookDisplayName(book)}`;

  const getPinLabel = (book) =>
    `${book.isPinned ? "Unpin" : "Pin"} ${getBookDisplayName(book)}`;
  const handlePin = (id) => {
    setBookRoomList((prev) =>
      prev.map((book) =>
        book.bookId === id ? { ...book, isPinned: !book.isPinned } : book,
      ),
    );

    setBookList((prev) =>
      prev.map((book) =>
        book.bookId === id ? { ...book, isPinned: !book.isPinned } : book,
      ),
    );
  };
  const handleShowTutorialPopup = (videoType) => {
    setIsShowTutorialPopup(true);
    if (userVO && userVO.userRole === "Student") {
      switch (videoType) {
        case "ConnectedQuiz":
          setShowTutorialPopup({
            popupHeading: "Connected Quizzing Tutorial",
            popupDescr:
              "Watch the video below to familiarize yourself with the Connected Quizzing features.",
            popupVideoUrl:
              "https://player.vimeo.com/video/763524348?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
          });
          break;
        case "PracticePerfect":
          setShowTutorialPopup({
            popupHeading: "PracticePerfect Tutorial",
            popupDescr: `Watch the video below to familiarize yourself with the features on PracticePerfect,
                        including the videos, quizzes, and progress dashboards.`,
            popupVideoUrl:
              "https://player.vimeo.com/video/765752778?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
          });
          break;
        default:
          setShowTutorialPopup({
            popupHeading: "Casebook Connect Tutorial",
            popupDescr: `Whether you're new around here or returning for your current semester, we're happy to share the latest
                        features on Casebook Connect. Watch the video below to familiarize yourself with the platform.`,
            popupVideoUrl:
              "https://player.vimeo.com/video/765743286?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
          });
          break;
      }
    } else if (userVO && userVO.userRole === "Professor") {
      setShowTutorialPopup({
        popupHeading: "Casebook Connect Professor Tutorial",
        popupDescr: `Whether you're new around here or returning for your current semester, we're happy to share the latest
                features on Casebook Connect. Watch the video below to familiarize yourself with the platform.`,
        popupVideoUrl:
          "https://player.vimeo.com/video/765743506?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
      });
    }
  };
  const handleAccessCodeKeyPress = (e) => {
    if (e.key === "Enter") {
      handleRedeemAccessCode();
    }
  };
  const handleHideRedeemAccessCode = () => {
    setRedeemCode("");
    setRedeemCodeErr("");
  };
  const handleRedeemAccessCode = () => {
    if (redeemCode && redeemCode.trim().length > 0) {
      setIsBookShelfLoading(true);
      saveBooktoBookShelf();
    }
  };
  const handlePlusFilterIcon = (iconName) => {
    setRedeemCode("");
    setRedeemCodeErr("");
    setRedeemSearchActive((prev) => (prev === iconName ? "" : iconName));
    if (iconName === "filter") {
      let userBooks = { bookList };
      setBookRoomList(userBooks.bookList);
    }
  };
  const handleBookSearch = (e) => {
    var userBooks = { bookList };
    setBookRoomList(
      userBooks.bookList.filter(
        (bk) =>
          bk.bookTitle
            .toLowerCase()
            .replace(/\s/g, " ")
            .indexOf(e.target.value.toLowerCase().trim()) >= 0 ||
          (bk.bookAuthor !== undefined &&
            bk.bookAuthor
              .toLowerCase()
              .replace(/\s/g, " ")
              .indexOf(e.target.value.toLowerCase()) >= 0) ||
          (bk.bookISBN !== undefined &&
            bk.bookISBN
              .toLowerCase()
              .replace(/\s/g, " ")
              .indexOf(e.target.value.toLowerCase()) >= 0),
      ),
    );
  };
  function fetchBookList() {
    post("/bookShelfRetrivalService/getBookList", {}, "ENV")
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "false" && data.wkErrorCode) {
          handleException(data);
        }
        if (data.status === "true" && data.bookVOList) {
          let bookVoDataList = data.bookVOList;
          bookVoDataList = Array.isArray(bookVoDataList)
            ? bookVoDataList
            : [bookVoDataList];

          // Adding Pin state here
          bookVoDataList = bookVoDataList.map((bookItem) => ({
            ...bookItem,
            isPinned:
              bookItem.pinnedFlag === "yes" || bookItem.pinnedFlag === true,
          }));
          bookVoDataList.forEach((bookItem) => {
            if (bookItem.bookType === "ConnectedQuiz" && bookItem.assistantFlag)
              localStorage.setItem("cqassistantFlag", bookItem.assistantFlag);
          });

          setBookList(bookVoDataList);
          setIsBookShelfLoading(false);
          setBookRoomList(bookVoDataList);
          localStorage.setItem(
            "getBookList",
            JSON.stringify({ bookVOList: bookVoDataList }),
          );
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
        setIsBookShelfLoading(false);
      });
  }
  function saveBooktoBookShelf() {
    let reqData = { bookVO: { bookAccessCode: redeemCode } };
    post("/manageBookService/saveBookInBookshelf", reqData, "ENV")
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "false" && data.wkErrorCode) {
          let wkErrMsg = "";
          if (
            data.wkErrorCode ===
            "bus.exception.user.already.have.all.books.with.life.time.access"
          ) {
            wkErrMsg =
              "Error: You already have lifetime access to this product.";
          } else if (
            data.wkErrorCode ===
            "bus.exception.you.have.longer.validity.period.than.the.used.access.code"
          ) {
            wkErrMsg =
              "Error: Code cannot be redeemed because it expires before current product expiration date.";
          } else if (
            data.wkErrorCode === "bus.exception.accesscode.has.expired"
          ) {
            wkErrMsg =
              "Error: This access code has already expired and cannot be redeemed.";
          } else if (
            data.wkErrorCode ===
            "bus.exception.you.already.have.lifetime.access.to.this.product"
          ) {
            wkErrMsg =
              "Error: You already have lifetime access to this product.";
          } else if (
            data.wkErrorCode === "bus.exception.only.student.can.redeem.cq.code"
          ) {
            wkErrMsg =
              "Error: It looks like you're trying to redeem a student access code with" +
              " a professor account. To get set up with Connected Quizzing, contact the Quiz Concierge at" +
              " <a href='mailto:concierge@aspenpublishing.com'>concierge@aspenpublishing.com</a>.";
          } else if (
            data.wkErrorCode ===
              "bus.exception.access.code.already.been.used" ||
            data.wkErrorCode ===
              "bus.exception.collection.access.code.has.already.been.used"
          ) {
            wkErrMsg =
              "Error: You have already redeemed this access code. Please try a different code.";
          } else if (
            data.wkErrorCode === "bus.exception.accessCode.is.null" ||
            data.wkErrorCode === "bus.exception.invalid.accesscode"
          ) {
            wkErrMsg =
              "Error: This is an Invalid access code. Please try a different code.";
          } else if (
            data.wkErrorCode ===
              "bus.exception.book.already.availded.by.user" ||
            data.wkErrorCode ===
              "bus.exception.book.already.availded.by.loginuser"
          ) {
            wkErrMsg = "Error: You already have access to this book.";
          } else if (
            data.wkErrorCode ===
              "bus.exception.product.already.availded.by.loginuser" ||
            data.wkErrorCode === "bus.exception.already.have.a.active.product"
          ) {
            wkErrMsg = "Error: You already have access to this product.";
          } else {
            handleException(data);
          }
          setRedeemCodeErr(wkErrMsg);
          setIsBookShelfLoading(false);
        }
        if (data.status === "true" && data.bookVOList) {
          let savedBookDataList = data.bookVOList;
          savedBookDataList = Array.isArray(savedBookDataList)
            ? savedBookDataList
            : [savedBookDataList];
          fetchBookList();
          setRedeemSearchActive("");
          handleHideRedeemAccessCode();
          setIsBookShelfLoading(false);
          handleShowTutorialPopup(savedBookDataList[0].bookType);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  return (
    <React.Fragment>
      <Spinner
        loading={isBookShelfLoading}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      {bookList && (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 ml-3 no-padding bookShelfContainer">
          <div className="col-xs-12 col-lg-12 col-md-12 col-sm-12 bookShelfPlate">
            <div className="bookShelfTopNav">
              <label className="bookShelfUserName">{`${userName}'s Bookshelf`}</label>
              <div className="rightTools input-group-btn">
                <button
                  type="button"
                  id="redeemCode"
                  data-testid="redeemSearchActivePlus"
                  className={`bg-transparent bookshelfIconButton ${
                    redeemSearchActive === "plus" ? "bsIconActive" : ""
                  }`}
                  aria-label="Redeem Access Code"
                  aria-haspopup="true"
                  aria-expanded={
                    redeemSearchActive === "plus" ? "true" : "false"
                  }
                  aria-controls="redeemBookShelfId"
                  title="Redeem Access Code"
                  onClick={() => handlePlusFilterIcon("plus")}
                >
                  <FaPlus
                    className="bookShelfIcons"
                    aria-hidden="true"
                    focusable="false"
                  />
                </button>

                <button
                  type="button"
                  id="filterProduct"
                  data-testid="redeemSearchActiveFilter"
                  className={`bg-transparent bookshelfIconButton ${
                    redeemSearchActive === "filter" ? "bsIconActive" : ""
                  }`}
                  aria-label="Filter Bookshelf Titles"
                  aria-haspopup="true"
                  aria-expanded={
                    redeemSearchActive === "filter" ? "true" : "false"
                  }
                  aria-controls="filterBookShelfId"
                  title="Filter Bookshelf Titles"
                  onClick={() => handlePlusFilterIcon("filter")}
                >
                  <FaFilter
                    className="bookShelfIcons"
                    aria-hidden="true"
                    focusable="false"
                  />
                </button>
              </div>
            </div>
          </div>
          {redeemSearchActive === "plus" ? (
            <div className="col-xs-12 col-lg-12 col-md-12 col-sm-12 no-padding">
              <div
                className="redeemPlate"
                id="redeemBookShelfId"
                aria-labelledby="redeemCode"
              >
                {redeemCodeErr ? (
                  <span
                    id="addBookError"
                    className="popover-error-msg error-label"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    {redeemCodeErr}
                  </span>
                ) : null}
                <p className="redeemCodeTitle">Redeem an Access Code </p>
                <div className="redeemInputBox">
                  <input
                    data-testid="redeemCode"
                    type="text"
                    name="redeemCode"
                    id="book-accesscode-area"
                    aria-label="Enter access code"
                    aria-describedby={
                      redeemCodeErr ? "addBookError" : undefined
                    }
                    aria-invalid={redeemCodeErr ? "true" : "false"}
                    autoComplete="off"
                    className="accessCodeTxtbox redeemCode acTextBox ember-view ember-text-field form-control text-box-common"
                    value={redeemCode}
                    onChange={(e) => {
                      setRedeemCode(e.target.value);
                      if (redeemCodeErr) {
                        setRedeemCodeErr("");
                      }
                    }}
                    onKeyPress={(e) => handleAccessCodeKeyPress(e)}
                  />
                  <span className="input-group-btn">
                    <button
                      id="add-book-new-book"
                      data-testid="redeemButton"
                      type="button"
                      className="redeemButton"
                      title="Redeem"
                      onClick={handleRedeemAccessCode}
                    >
                      Redeem
                    </button>
                  </span>
                </div>
              </div>
            </div>
          ) : redeemSearchActive === "filter" ? (
            <div className="col-xs-12 col-lg-12 col-md-12 col-sm-12 no-padding">
              <div
                className="searchPlate"
                id="filterBookShelfId"
                aria-labelledby="filterProduct"
              >
                <label className="searchTitle">Filter Bookshelf Titles</label>
                <div className="searchInputBox">
                  <input
                    data-testid="searchBookshelf"
                    type="text"
                    name="searchBookshelf"
                    aria-label="Filter by Title, Author, or Course"
                    autoComplete="off"
                    id="txtBookRoomSearch"
                    className="redeemCode acTextBox ember-view ember-text-field form-control text-box-common"
                    onChange={handleBookSearch}
                  ></input>
                  <span className="input-group-btn">
                    <button
                      data-testid="searchButton"
                      type="button"
                      id="searchButton"
                      className="searchButton"
                      title="search"
                    >
                      Search
                    </button>
                  </span>
                </div>
              </div>
            </div>
          ) : null}
          <div className="col-xs-12 col-lg-12 col-md-12 col-sm-12 no-padding">
            <div className="BookScroll" tabIndex="0">
              <div className="BookList mr-3 ml-2 mt-2 mb-3">
                <CardDeck>
                  {bookRoomList &&
                    bookRoomList.map((book, index) => {
                      const authorname =
                        book.bookAuthor !== undefined
                          ? "by " + book.bookAuthor
                          : "";
                      const coverImg =
                        book.bookType === "ConnectedQuiz"
                          ? CqCoverImg
                          : book.bookReadyForUseFlag &&
                              book.bookReadyForUseFlag === "yes"
                            ? book.thumbnailImagePath
                              ? book.thumbnailImagePath
                              : "/cc/images/CC_comingSoon.png"
                            : "/cc/images/CC_comingSoon.png";
                      return (
                        <div
                          key={book.bookId}
                          className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-6 mb-2"
                        >
                          <div className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10">
                            <Card
                              style={{
                                width: "14rem",
                                height: "auto",
                                border: "none",
                              }}
                            >
                              <Card.Img
                                data-testid={`book_${book.bookId}`}
                                variant="top"
                                src={coverImg}
                                alt={`${book.bookType ? book.bookType + " for " : ""}${book.bookTitle}`}
                                style={{ width: "70%", height: "70%" }}
                                bookid={book.bookId}
                                booktype={book.bookType}
                                booktitle={book.bookTitle}
                                bookisbn={book.bookISBN}
                                chapterid={book.chapterId}
                                tocpath={book.tocPath}
                                onClick={handleGetBookContent}
                              />
                              <Card.Body>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "5px",
                                  }}
                                >
                                  <div
                                    style={{
                                      heigth: "16px !important",
                                      width: "16px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="ThumbtackButton"
                                      aria-pressed={
                                        book.isPinned ? "true" : "false"
                                      }
                                      aria-label={getPinLabel(book)}
                                      title={book.isPinned ? "Unpin" : "Pin"}
                                      onClick={() => handlePin(book.bookId)}
                                      style={{
                                        border: "0px",
                                        backgroundColor: "transparent",
                                      }}
                                    >
                                      <FaThumbtack
                                        aria-hidden="true"
                                        focusable="false"
                                        style={{
                                          color: book.isPinned
                                            ? "#85BC20"
                                            : "#BFBFBF",
                                        }}
                                        className="ThumbtackIcon"
                                      />
                                    </button>
                                  </div>
                                  <Card.Title className="bookRoomTitle">
                                    <div>
                                      <a
                                        href="/#"
                                        bookid={book.bookId}
                                        booktype={book.bookType}
                                        booktitle={book.bookTitle}
                                        bookisbn={book.bookISBN}
                                        chapterid={book.chapterId}
                                        tocpath={book.tocPath}
                                        onClick={handleGetBookContent}
                                      >
                                        {book.bookType === "ConnectedQuiz"
                                          ? `Connected Quizzing`
                                          : book.bookType === "PracticePerfect"
                                            ? `PracticePerfect ${book.bookTitle}`
                                            : book.bookTitle}
                                      </a>
                                      <br />
                                      <p>{authorname}</p>
                                    </div>
                                  </Card.Title>
                                </div>
                                <Card.Text>
                                  {book.validityStatus
                                    ? book.validityStatus === "Life time"
                                      ? ""
                                      : (book.validityStatus === "active"
                                          ? `Expires: `
                                          : `Expired: `) +
                                        book.accessCodeExpirationDate
                                    : ""}
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      );
                    })}
                </CardDeck>
              </div>
            </div>
          </div>
          <Modal
            size="lg"
            contentClassName="p-4"
            centered
            show={isShowTutorialPopup}
            onHide={() => setIsShowTutorialPopup(false)}
            id="tutorialVideoModalId"
            aria-labelledby="bookroom-tutorial-title"
            aria-describedby="bookroom-tutorial-desc"
          >
            <Modal.Header closeButton closeLabel="Close dialog">
              <Modal.Title
                className="tutorialPopupTitle"
                id="bookroom-tutorial-title"
              >
                {showTutorialPopup.popupHeading}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              <p className="tutorialPopupTxt mb-2" id="bookroom-tutorial-desc">
                {showTutorialPopup.popupDescr}
              </p>
              <div className="modal-content" id="tutorialPopupContentId">
                <div className="tutorialPopupContentDiv">
                  <iframe
                    data-testid="videoShowTutorial"
                    id="iframeid"
                    title="video"
                    src={showTutorialPopup.popupVideoUrl}
                    allowFullScreen
                    allow="encrypted-media"
                    className="iframe-video"
                  />
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </React.Fragment>
  );
}
